var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInformation1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6128_4116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 0C7.60332 0 0 7.60398 0 17C0 26.3967 7.60398 34 17 34C26.3967 34 34 26.396 34 17C34 7.60332 26.396 0 17 0ZM17 31.3438C9.07156 31.3438 2.65625 24.9279 2.65625 17C2.65625 9.07156 9.07209 2.65625 17 2.65625C24.9284 2.65625 31.3438 9.07209 31.3438 17C31.3438 24.9284 24.9278 31.3438 17 31.3438Z",
    fill: "#005DA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 14.2324C16.2665 14.2324 15.6719 14.827 15.6719 15.5605V24.1132C15.6719 24.8467 16.2665 25.4413 17 25.4413C17.7335 25.4413 18.3281 24.8467 18.3281 24.1131V15.5605C18.3281 14.827 17.7335 14.2324 17 14.2324Z",
    fill: "#005DA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 12.6074C17.9902 12.6074 18.793 11.8047 18.793 10.8145C18.793 9.82422 17.9902 9.02148 17 9.02148C16.0098 9.02148 15.207 9.82422 15.207 10.8145C15.207 11.8047 16.0098 12.6074 17 12.6074Z",
    fill: "#005DA8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6128_4116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation1);
export default __webpack_public_path__ + "static/media/information1.90ded63b795e829e78b803de84496fde.svg";
export { ForwardRef as ReactComponent };